import { AirbrakeClient } from './AirbrakeClient';
import { PerformanceTracker } from './PerformanceTracker';

class ObservabilityAppService {
  public notify(error: unknown, info?: unknown, context?: Record<string, unknown>): void {
    if (this.isTurnedOff()) {
      return;
    }

    AirbrakeClient.notify(error, info, context);
  }

  public createPerformanceTracker(
    key: string,
    {
      tags = [],
    }: {
      tags?: string[];
    } = {}
  ): PerformanceTracker {
    return new PerformanceTracker(key, { tags }, this.notify.bind(this));
  }

  private isTurnedOff() {
    return false;
  }
}

export const observabilityAppService = new ObservabilityAppService();
